import "./biography.css";
import { useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase/config";

import { FaGraduationCap } from "react-icons/fa";
import { HiAcademicCap } from "react-icons/hi";
import { MdLocationOn } from "react-icons/md";

export default function Biography() {

  const defaultData = {
    para1: "Loading biography...",
    para2: "",
    designation: "Professor",
    qualification: "M.A. Ph.D. Marathi",
    location: "Maharashtra, India"
  };

  const [data, setData] = useState(defaultData);

  useEffect(() => {
    // 🔥 LOAD CACHE FIRST
    const cached = localStorage.getItem("bioData");
    if (cached) {
      try {
        setData(JSON.parse(cached));
      } catch (e) {}
    }

    // 🔥 FIRESTORE REALTIME
    const ref = doc(db, "siteContent", "bio");

    const unsubscribe = onSnapshot(ref, (snap) => {
      if (snap.exists()) {
        const fresh = snap.data();
        setData(fresh);
        localStorage.setItem("bioData", JSON.stringify(fresh));
      }
    });

    return () => unsubscribe();
  }, []);

  return (
    <section className="bio" id="bio">
      <div className="bio-container">

        <h2>Professional Biography</h2>

        <p className="bio-text">{data.para1}</p>
        <p className="bio-text">{data.para2}</p>

        <div className="bio-cards">

          <div className="bio-card">
            <div className="icon grad">
              <FaGraduationCap />
            </div>
            <p className="label">Designation</p>
            <h4>{data.designation}</h4>
          </div>

          <div className="bio-card">
            <div className="icon edu">
              <HiAcademicCap />
            </div>
            <p className="label">Qualification</p>
            <h4>{data.qualification}</h4>
          </div>

          <div className="bio-card">
            <div className="icon loc">
              <MdLocationOn />
            </div>
            <p className="label">Location</p>
            <h4>{data.location}</h4>
          </div>

        </div>

      </div>
    </section>
  );
}